module.exports = {"title":"Terms and Conditions | GoGoVan Hong Kong","legal_headline":"Terms and Conditions"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/en_hk/setting/legal/locale.json
// module id = 600
// module chunks = 0 1 2 3 4 5